import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getClockOutModalOpen } from 'lib/selectors/getClockOutModalOpen';
import { actionCloseClockOutModal, actionOpenClockOutFlow } from 'lib/actions';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(26, 32, 44, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  width: 544px;
  height: 296px;
  background: #ffffff;
  box-shadow: 0px 0px 1px rgba(26, 32, 44, 0.2),
    0px 26px 80px rgba(26, 32, 44, 0.2);
  border-radius: 8px;
`;

const ModalHeader = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 8px 12px 16px;
  gap: 16px;
  width: 544px;
  height: 72px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
`;

const HeaderText = styled.div`
  width: 456px;
  height: 24px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.005em;
  color: #4a5568;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px;
  gap: 16px;
  width: 544px;
  height: 224px;
  background: #ffffff;
  border-bottom: 1px solid #cbd5e0;
`;

const Button = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  width: 464px;
  height: 64px;
  background: #ffffff;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.005em;
  color: #4a5568;
  cursor: pointer;

  &:hover {
    background: #f7fafc;
  }
`;

export const ClockOutModal = React.memo(() => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isOpen = useSelector(getClockOutModalOpen);

  if (!isOpen) return null;

  const handleClose = () => {
    dispatch(actionCloseClockOutModal());
  };

  const handleClockOut = () => {
    handleClose();
    dispatch(actionOpenClockOutFlow());
  };

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>
          <HeaderText>{t('Clock out for the day?')}</HeaderText>
        </ModalHeader>
        <ButtonContainer>
          <Button onClick={handleClockOut}>{t('Yes')}</Button>
          <Button onClick={handleClose}>{t('No')}</Button>
        </ButtonContainer>
      </ModalContainer>
    </ModalOverlay>
  );
});
